export default __webpack_public_path__ + "static/media/skp-flexigeld-card-background.03ea53c0.png";